import { Injectable } from '@angular/core';
import { GetHostsModelResponse } from '../_models/Host/HostModel';
import { of, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HostService {

  hostChanged = new Subject<GetHostsModelResponse[]>();

  private hosts: GetHostsModelResponse[] = [];

  private tmp_hosts: GetHostsModelResponse[] = [];

  constructor() { }

  getHosts() {
    return this.hosts.slice();
  }
  
  //not using at the moment
  getHost(index: number) {
    return this.hosts[index];
  }
  
  //not using at the moment
  addHost(host: GetHostsModelResponse) {
    this.hosts.push(host)
    this.hostChanged.next(this.hosts.slice());
  }
  //Using when creating Hosts,for Update not using at the moment
  setHosts(hosts: GetHostsModelResponse[]) {
    this.hosts = hosts;
    this.hostChanged.next(this.hosts.slice());
  }

  //for multi-select-dropdown
  setTempHosts(hosts: GetHostsModelResponse[]){
    this.tmp_hosts = hosts;
  }

  //for multi-select-dropdown
  getTempHosts(){
    console.log(this.tmp_hosts.slice());
    return this.tmp_hosts.slice();
  }

  //not using at the moment
  deleteHost(index: number) {
    this.hosts.splice(index, 1);
    this.hostChanged.next(this.hosts.slice());
  }
}
